import React from "react";

import { Preview } from "@creatomate/preview";

import ThumbnailTitle from "./ThumbnailTitle";
import ThumbnailOptions from "./ThumbnailOptions";
import ThumbnailImage from "./ThumbnailImage";

interface ThumbnailProps {
  preview: Preview;
}

const Thumbnail: React.FC<ThumbnailProps> = ({ preview }) => (
  <>
    <div className="Captions-Header__Title">
      <ThumbnailTitle />
      <ThumbnailOptions preview={preview} />
    </div>
    <ThumbnailImage />
  </>
);

export default Thumbnail;
